export default __webpack_public_path__ + "static/media/alamo-arte-9.9527fc3e.webp";